import React, { useState } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.style.css";

import CompanyInformationPage from "../../Pages/CompanyInformationPage/CompanyInformationPage.js";
import PrivacyPage from "../../Pages/PrivacyPage/PrivacyPage.js";
import AboutUsPage from "../../Pages/AboutUsPage/AboutUsPage";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import Data from "../../Assets/Content/ContentData.js";
import ContactPage from "../../Pages/ContactPage/ContactPage";
import MaterialPage from "../../Pages/MaterialPage/MaterialPage";
import MainPage from "../../Pages/MainPage/MainPage";

const App = () => {
  const [page, setPage] = useState("MainPage");
  const [content, setContent] = useState(Data.CycleMain);
  const [economyType, setEconomyType] = useState("cycle");

  // Lifted state from MainPage
  const [view, setView] = useState("Intro");
  const [activeCard, setActiveCard] = useState(null);
  const [circularEconomyState, setCircularEconomyState] = useState(true);

  let onChangePage = (e) => {
    setPage(e);
  };

  let onChangeView = (e, cardKey = null) => {
    setView(e);
    setActiveCard(cardKey);
  };

  let onChangeEconomySwitch = (e) => {
    let eS = circularEconomyState;
    eS = !eS;
    console.log("Circular Economy", eS);
    setCircularEconomyState(eS);
    let val = "linear";
    if (eS === true) {
      val = "circular";
    }
    setEconomyType(val);
    if (val === "linear") {
      setContent(Data.LinearMain);
      setEconomyType(val);
    } else {
      setContent(Data.CycleMain);
      setEconomyType(val);
    }
  };

  let getPage = () => {
    if (page === "CompanyInformationPage") {
      return <CompanyInformationPage />;
    } else if (page === "PrivacyPage") {
      return <PrivacyPage />;
    } else if (page === "MainPage") {
      return (
        <MainPage
          AppStateService={{ content, setContent, economyType, setEconomyType }}
          view={view}
          activeCard={activeCard}
          onChangeView={onChangeView}
          circularEconomyState={circularEconomyState}
          onChangeEconomySwitch={onChangeEconomySwitch}
        />
      );
    } else if (page === "MaterialPage") {
      return <MaterialPage />;
    } else if (page === "AboutUsPage") {
      return <AboutUsPage />;
    } else if (page === "ContactPage") {
      return <ContactPage />;
    }
  };

  return (
    <div className="app-container">
      <Navbar onChangePage={onChangePage} onChangeView={onChangeView} />
      <div className="content-wrap">{getPage()}</div>
      <Footer onChangePage={onChangePage} />
    </div>
  );
};

export default App;
